import { buildProps, definePropType } from '@ll-plus/utils'
import { BackTopProps as AntBackTopProps } from 'ant-design-vue'
import { ExtractPropTypes } from 'vue'
import { IconProps } from '../../icon'
import type BackTop from './back-top.vue'

export const backTopProps = buildProps({
  show: {
    type: definePropType<boolean | string>([Boolean, String]),
    default: 'auto',
  },
  target: {
    type: definePropType<AntBackTopProps['target']>(Function),
    default: undefined,
  },
  visibilityHeight: {
    type: Number,
    default: 400,
  },
  //  图标信息
  icon: {
    type: definePropType<IconProps>(Object),
    default: () => ({
      iconName: '',
      color: '',
      size: '',
    }),
  },
  description: {
    type: String,
    default: '',
  },
  shape: {
    type: String,
    values: ['circle', 'square'],
    default: 'circle',
  },
})

export type BackTopProps = ExtractPropTypes<typeof backTopProps>

// instance
export type BackTopInstance = InstanceType<typeof BackTop>
